import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { TasksActionTypesService } from 'src/app/tasks/tasks-action-types.service';

@Component({
  selector: 'app-tasks-actions-types-detail',
  templateUrl: './tasks-actions-types-detail.component.html',
  styleUrls: ['./tasks-actions-types-detail.component.scss']
})
export class TasksActionsTypesDetailComponent implements OnInit {

  public taskActionType: any = {}

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private taskActionTypesService: TasksActionTypesService,
    private coreDialogService: CoreDialogService
  ) { }

  ngOnInit(): void {
    this.loadData(this.config.data.id);
  }
  loadData(id) {
    if (id != 0 && id != null) {
      this.taskActionTypesService.get(id).subscribe(
        data => {
          this.taskActionType = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: '¿Quieres borrar el tipo ' + this.taskActionType.name + '?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.taskActionTypesService.delete(this.taskActionType.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: 'Borrado correctamente' });
            this.dynamicDialogRef.close(data);
          }
        ),
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
      },
      reject: () => {

      }
    });
  }
  /*
  isDuplied() {
    this.taskActionTypesService.isDuplied(this.taskActionType).subscribe(
      data => {
        if(data == true){
          this.coreDialogService.notify({
            message:  "Ya existe un tipo de acción con estos datos proporcionados." ,
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });          
        }else{
          this.save();
        }
      }
    );
  }
  */

  save() {
    if (typeof this.taskActionType.id === "undefined") {
      this.taskActionTypesService.add(this.taskActionType).subscribe(
        data => {
          this.taskActionType = data;
          this.loadData(this.taskActionType.id);
          this.messageService.add({ closable: false, severity: "success", detail: "Guardado correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.taskActionTypesService.save(this.taskActionType.id, this.taskActionType).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Guardado correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
  }

}
